<template>
    <div class="linksUser" v-if="isAllowedToSee || userId == 10">
        <div class="container-fluid">
            <div class="card center card--flex">
                <div class="div__cont">
                    <div class="ambassadors__links">
                        <div class="input--out col-sm-8">
                            <span>{{translation.label_link_franchisee_plan}}</span>
                            <div class="b-b-i">
                                <input
                                    type="text"
                                    :value="linkFranchisee"
                                    id="general-franchisee-share-link"
                                    class="general-input"
                                />
                                <div
                                    class="copy ic-copy"
                                    :data-clipboard-target="'#general-franchisee-share-link'"
                                    data-label-copy="copied"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
    name: "links-user-franchisee",
    props: ["props"],
    components: {},
    data() {
        return {
            translation: this.$parent.view.translation.franchiseeLink,
            linkFranchisee: null,
            isAllowedToSee: false,
            userId: null
        };
    },
    mounted() {
        this.linkFranchisee = this.props.linkFranchiseePlan;
        this.isAllowedToSee = this.props.isAllowed;
        this.userId = this.props.userId;
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.linksUser {
    .div__cont {
        // max-width: 800px;
        width: 90%;
        // min-width: 314px;
    }
    .container-fluid {
        padding-right: 0;
        padding-left: 0;

        .card {
            margin-bottom: 10px;
            margin-top: 17px;
            background: var(--theme-color-primary);
        }
    }
    .in-line {
        display: flex;
        margin-bottom: 6px;
        width: 100%;
    }
    .div__btns {
        width: 100%;
        margin-bottom: 5px;
        .btn__link {
            align-items: center;
            justify-content: center;
            display: block;
            background: #0294ff;
            color: white;
            font-weight: 700;
            border-radius: 4px;
            -webkit-transition: 0.3s all;
            transition: 0.3s all;
            text-align: center;
            margin-right: 12px;
            height: 40px;
            display: flex;
            padding: 10px;
            font-size: 15px;
            align-items: center;
            cursor: pointer;
            width: 100%;
        }
    }
}
.info__token {
    span {
        color: white;
        font-size: 15px;
        &:first-child {
            font-weight: 700;
        }
    }
}
.ic-copy {
    width: 19px;
    height: 18px;
    background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0id2hpdGUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMCkiPgo8cGF0aCBkPSJNOS40NzAwMiAxNEgyLjE3ODQyQzEuMjkzNDkgMTQgMC41NzQyMTkgMTMuMjgwNyAwLjU3NDIxOSAxMi4zOTU4VjQuNTIwOEMwLjU3NDIxOSAzLjYzNTg2IDEuMjkzNDkgMi45MTY3IDIuMTc4NDIgMi45MTY3SDIuNDcwMDJDMi43MTE1MiAyLjkxNjcgMi45MDc1MiAzLjExMjcgMi45MDc1MiAzLjM1NDJDMi45MDc1MiAzLjU5NTcgMi43MTE1MiAzLjc5MTcgMi40NzAwMiAzLjc5MTdIMi4xNzg0MkMxLjc3NjQ5IDMuNzkxNyAxLjQ0OTIyIDQuMTE4ODcgMS40NDkyMiA0LjUyMDhWMTIuMzk1OEMxLjQ0OTIyIDEyLjc5NzcgMS43NzY0OSAxMy4xMjUgMi4xNzg0MiAxMy4xMjVIOS40NzAwMkM5Ljg3MTk1IDEzLjEyNSAxMC4xOTkyIDEyLjc5NzcgMTAuMTk5MiAxMi4zOTU4VjEyLjEwNDJDMTAuMTk5MiAxMS44NjI3IDEwLjM5NTIgMTEuNjY2NyAxMC42MzY3IDExLjY2NjdDMTAuODc4MiAxMS42NjY3IDExLjA3NDIgMTEuODYyNyAxMS4wNzQyIDEyLjEwNDJWMTIuMzk1OEMxMS4wNzQyIDEzLjI4MDcgMTAuMzU0OSAxNCA5LjQ3MDAyIDE0WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTExLjgwMzQgMTAuNUg1LjY3ODQyQzQuNzkzNDkgMTAuNSA0LjA3NDIyIDkuNzgwNzMgNC4wNzQyMiA4Ljg5NThWMS42MDQyQzQuMDc0MjIgMC43MTkyNjkgNC43OTM0OSAwIDUuNjc4NDIgMEgxMS44MDM0QzEyLjY4ODQgMCAxMy40MDc1IDAuNzE5MjY5IDEzLjQwNzUgMS42MDQyVjguODk1OEMxMy40MDc1IDkuNzgwNzMgMTIuNjg4NCAxMC41IDExLjgwMzQgMTAuNVpNNS42Nzg0MiAwLjg3NUM1LjI3NjQ5IDAuODc1IDQuOTQ5MjIgMS4yMDIyNyA0Ljk0OTIyIDEuNjA0MlY4Ljg5NThDNC45NDkyMiA5LjI5NzczIDUuMjc2NDkgOS42MjUgNS42Nzg0MiA5LjYyNUgxMS44MDM0QzEyLjIwNTQgOS42MjUgMTIuNTMyNSA5LjI5NzczIDEyLjUzMjUgOC44OTU4VjEuNjA0MkMxMi41MzI1IDEuMjAyMjcgMTIuMjA1NCAwLjg3NSAxMS44MDM0IDAuODc1SDUuNjc4NDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjE5IiBoZWlnaHQ9IjE5IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==);
    display: block;
}
span {
    color: white;
    font-size: 15px;
}
.card--flex {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // .width-full{
    //   width: 100%;
    // }
    .width-full-dashboard {
        // width: 80%;
    }
    .input--out {
        // padding: 0.6rem 1rem;
        border-radius: 8px;
        display: flex;
        align-items: center;
        color: white;
        // margin: 0.6rem 0;
        height: 40px;
        font-size: 15px;
        padding: 0 5px 0 5px;
        margin-bottom: 5px;
        position: relative;
        justify-content: space-evenly;
        span {
            font-weight: 700;
            font-size: 15px;
            flex: 1;
        }

        .copy {
            // float: right;
            // position: absolute;
            // right: 10px;
        }
        .general-input {
            width: 90%;
            font-size: 0.8rem;
            padding: 0 1rem !important;
        }
        .b-b-i {
            display: flex;
            border-bottom: 1px solid white;
            padding-bottom: 0.3rem;
            justify-content: space-between;
            flex: 4;
        }
        input {
            border: 0;
            // margin: 0 0.8rem;
            padding: 0;
            background: var(--theme-color-primary);
            &:focus {
                padding: 0;
                outline: none;
            }
        }
        a {
            margin-left: 3px;
            color: white;
            font-weight: 100;
        }
    }
    .ambassadors__links {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
        .select__lenguage {
            margin-left: 4px;
            padding: 0rem;
            border: 1px solid white;
            background: var(--theme-color-primary);
            padding: 0.6rem 1rem;
            border-radius: 5px;
            color: white;
            font-weight: 700;
            font-size: 15px;
            text-transform: uppercase;
            height: 40px;
            margin-bottom: 5px;
            &:focus {
                overflow: auto;
                outline: none;
                -webkit-box-shadow: none;
                -moz-box-shadow: none;
                box-shadow: none;
            }
        }
    }
    .limit__token__reached {
        font-weight: 700;
        font-size: 15px;
        color: white;
    }
    #js-ambassador-div-group-BRL,
    #js-ambassador-div-group-EUR {
        display: none;
    }
}
@media (max-width: 1150px) {
    .linksUser {
        margin: 0;
    }
    .linksUser .div__cont {
        max-width: unset;
        width: 100%;
    }
    .card--flex .input--out {
        width: 100%;
    }
}
@media (max-width: 450px) {
    .width-full-dashboard {
        flex-direction: column;
    }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/linkUserFranchisee.vue